import { render, staticRenderFns } from "./DebtorInfo.vue?vue&type=template&id=70c0df4a&"
import script from "./DebtorInfo.vue?vue&type=script&lang=js&"
export * from "./DebtorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports